import React from 'react';

const History_of_Languages = () => {
    return (
        <div>History_of_Languages Component</div>
    );
}

export default History_of_Languages;
